module.exports = __webpack_public_path__ + "static/img/p11.b05cc56.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/p11.png
// module id = 2+2q
// module chunks = 1